import { styled, SVGMol, SVGMolSpace } from '@moleculeone/ui';
import { Mol } from '@retro-ui/api-contract';

import { useMolDrawing } from '../../../hooks';

const Molecule = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '$4',
  backgroundColor: 'white',
  borderRadius: '$medium',
});

const MoleculeText = styled('p', {
  fontSize: '$2',
  marginTop: '$3',
});

type CompoundPreviewProps = {
  mol: Mol;
  onMouseDown: any;
  renderDelay?: number;
  text?: string;
  size?: number;
};
export const CompoundPreview = ({ mol, onMouseDown, renderDelay = 0, text, size = 150 }: CompoundPreviewProps) => {
  const drawing = useMolDrawing({ mol, renderDelay });

  return (
    <Molecule>
      {drawing == null ? (
        <div style={{ width: size, height: size }} />
      ) : (
        <SVGMolSpace viewport={drawing.viewport} onMouseDown={onMouseDown} width={size} height={size}>
          <SVGMol drawnMol={drawing.drawnMol} />
        </SVGMolSpace>
      )}
      {text && <MoleculeText>{text}</MoleculeText>}
    </Molecule>
  );
};
